import React from 'react';
import MaterialTable from 'material-table';
import { defaultGridOptions, useGridColDefs } from '../../utils/GridUtils';

const ServicePagesGrid = ({ data, onRowClick, tableRef }) => {
  const colDefs = useGridColDefs([
    { title: 'Nro. de hoja de servicio', field: 'serviceRecordCode' },
    { title: 'Fecha', field: 'dateServiceRecord', valueType: 'date' },
    { title: 'Moneda', field: 'currency', hidden: true },
    { title: 'Importe total', field: 'import', currencyRef: 'currency', hidden: onRowClick },
    { title: 'Nro. Pedido de compra', field: 'purchaseOrderCode', valueType: 'numeric' },
    { title: 'Texto', field: 'text' },
  ]);

  return (
    <div style={{ width: '100%' }}>
      <MaterialTable
        {...defaultGridOptions}
        onRowClick={onRowClick}
        columns={colDefs}
        data={data}
        tableRef={tableRef}
        options={{
          ...defaultGridOptions.options,
          pageSize: tableRef?.current?.dataManager?.pageSize || defaultGridOptions.options.pageSize,
        }}
      />
    </div>
  );
};

export default ServicePagesGrid;
